import React from 'react';
import CallCard from './call-card';
import { formatToReadableDate } from './constant';

const CallHistory = ({ calls, trialInfo, isAICallHistory = false }) => {
    // Group calls by dateGroupLabel
    const groupedCalls = calls.reduce((acc, call) => {
        const label = call.dateGroupLabel || 'Unknown';
        if (!acc[label]) acc[label] = [];
        acc[label].push(call);
        return acc;
    }, {});
    // Custom order: Today > Yesterday > Rest
    const customOrder = ['Today', 'Yesterday'];
    let sortedLabels = Object.keys(groupedCalls).sort((a, b) => {
        const aIndex = customOrder.indexOf(a);
        const bIndex = customOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
    });

    return (
        <div className="w-full">
            {sortedLabels.map((label) => {
                const callsForLabel = groupedCalls[label];
                const dateLabel = label==="Yesterday" || label === "Today" ? formatToReadableDate(callsForLabel[0].createdAt):label;

                return (
                    <div key={label} className="mb-5">
                        <p className={`text-md ${label === "Today" || label === "Yesterday" ? "font-semibold" : "font-medium"} mb-3 flex items-center gap-2`}>
                            <span className={label === "Today" || label === "Yesterday" ? "text-[#245CEA]" : "text-[#1B2A3D]"}>{dateLabel}</span>
                            {label === "Today" ? (
                                <>
                                    <span className='bg-[#C8D6E6] w-[1px]'>&nbsp;</span>
                                    <span className="text-[#245CEA]">Today</span>
                                </>
                            ) : label === "Yesterday" ? (
                                <>
                                    <span className='bg-[#C8D6E6] w-[1px]'>&nbsp;</span>
                                    <span className={label === "Yesterday" ? "text-[#245CEA]" : "text-[#1B2A3D]"}>Yesterday</span>
                                </>
                            ) : (
                                ''
                            )}
                        </p>
                        <ul className="space-y-3">
                            {callsForLabel.map((call, index) => (
                                <CallCard
                                    key={index}
                                    name={trialInfo.patientName}
                                    callTime={call.callTime}
                                    duration={call.duration}
                                    status={call.callStatus}
                                    isAICallHistory={isAICallHistory}
                                    voiceAgentCallId={call.voiceAgentCallId}
                                    endedReason={call.endedReason}
                                />
                            ))}
                        </ul>
                    </div>
                );
            })}
        </div>
    );
};

export default CallHistory;
